<template>
  <Table v-bind="$attrs" v-on="$listeners"></Table>
</template>

<script>
  import styles from './render.module.less'

  export default {
    name: 'BTable',
    props: {
      openAction: {
        type: Boolean,
        default: true
      },
      hideActions: {
        type: Array,
        default: () => {
          return []
        }
      },
      action: {
        type: Object,
        default: () => {
          return {
            title: '操作',
            fixed: 'right',
            align: 'center',
            minWidth: 90,
            name: 'action'
          }
        }
      }
    },
    data () {
      return {
        delStatus: false
      }
    },
    created () {
      this.openAction && this.mergeColumns()
    },
    methods: {
      mergeColumns () {
        const { columns } = this.$attrs
        if (columns === undefined || columns[columns.length - 1].name === 'action') {
          return
        }
        const merge = this.getActions()
        columns.push(merge)
        this.$attrs.columns = columns
      },
      getActions () {
        const action = { ...this.action }
        const hideActions = [...this.hideActions]
        let self = this
        return {
          ...action,
          render (h, params) {
            return (
              <div class={styles['table-btn']}>
                {
                  !hideActions.includes('view')
                    ? (<i-button className={styles['btn']} type="success" size="small"
                                 nativeOnClick={self.viewHandle.bind(self, params)}>查看
                    </i-button>) : ''
                }
                {
                  !hideActions.includes('editor')
                    ? (<i-button className={styles['btn']} nativeOnClick={self.editorHandle.bind(self, params)}
                                 type="primary"
                                 size="small">编辑
                    </i-button>) : ''
                }
                {
                  !hideActions.includes('delete')
                    ? (<Poptip placement="top" title="确认删除？" confirm={true} onOn-ok={self.ok.bind(self, params)}>
                      <i-button className={styles['btn']} type="error"
                                size="small">删除
                      </i-button>
                    </Poptip>) : ''
                }
              </div>
            )
          }
        }
      },
      viewHandle (params) {
        this.$emit('on-view', params)
      },
      editorHandle (params) {
        this.$emit('on-editor', params)
      },
      ok (params) {
        this.delStatus = false
        this.$emit('on-remove', params)
      }
    }
  }
</script>

<style scoped lang="less">

</style>
